import { Column, Entity, PrimaryGeneratedColumn, VersionColumn, CreateDateColumn, UpdateDateColumn } from 'typeorm';
@Entity('calibrations')
export class Calibrations {

    @PrimaryGeneratedColumn('increment', { name: 'calibration_id' })
    calibrationId: number;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'machine_description'
    })
    machineDescription: string;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'barcode_no'
    })
    barcodeNo: string;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'instrument'
    })
    instrument: string;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'instrument_make'
    })
    instrumentMake: string;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'model_type'
    })
    modelType: string;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'serial_no'
    })
    serialNo: string;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'plant'
    })
    plant: string;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'calibration_range'
    })
    calibrationRange: string;

    @Column('date', {
        nullable: false,
        name: 'calibration_due_on'
    })
    calibrationDueOn: Date;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'calibration_frequency'
    })
    calibrationFrequency: string;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'location'
    })
    location: string;

    
    @Column("varchar",{
        name:"file_name",
       })
       fileName?:string;
    
       @Column("varchar",{
       name:"file_path"
       })
       filePath?:string;
    

    @Column('boolean', {
        nullable: false,
        default: true,
        name: 'is_active'
    })
    isActive: boolean;

    @CreateDateColumn({
        name: 'created_at',
        type: 'datetime'
    })
    createdAt: Date;

    @Column('varchar', {
        nullable: false,
        name: 'created_user'
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at',
        type: 'datetime'
    })
    updatedAt: Date;

    @Column('varchar', {
        nullable: true,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;
}